<template>
  <div>
    <d-table
      v-if="tableReady"
      :data_object="data_object"
      v-bind="vBind"
      :getFreshData="true"
      :alwaysUpdate="true"
      :hasSearch="true"
      :searchLen="3"
      :defaultModel="defaultModel"
      :onDataReceived="onDataReceived"
      :tableReady="tableReady"
      :beforeSave="beforeSave"
      :hideAllTabFilter="true"
      ref="table"
    />
  </div>
</template>

<script>
import axios from "axios";

import DTable from "../components/Table";
import * as fun from "../plugins/common";

export default {
  name: "ReportWizard",
  components: { DTable },
  data: () => ({
    fields_excluded: [],
    fieldsData: {
      // object_name: "v_shipment_letter_fields",
    },
    schema: {},
    vBind: {
      alwaysUpdate: true,
      getFreshData: true,

      hasSearch: true,
      table_title: "Reports",
      newItemTitle: "Add Report",
      addButtonCaption: "New Report",
      editable: [],
      editRow: true
      // mainTabs: [
      //   {
      //     tabName: "Report Properties",
      //     tabId: 0,
      //   },
      //   {
      //     tabName: "Body",
      //     tabId: 1,
      //   },
      // ],

      // expandable: true,
    },
    data_object: {
      object_name: "reports",
      // object_name: "v_shipment_letter_fields",
      // schema_name: "report_wizard",
      // object_name_to_update: "roles",
      // db_name: "master",

      all_records: true,
      table_title: "reports",
      additional_structure: [
        {
          obj_name: "shipments"
        },
        {
          obj_name: "v_trip"
        },
        {
          obj_name: "employee"
        },
        {
          obj_name: "storage"
        }
      ]
    },
    defaultModel: {
      fields: [],
      type: "report",
      parent: "shipments"
    },
    categoryLabels: [{ objectName: "shipments", label: "shipment" }],
    dataLoaded: false,
    tree: [],
    treeObject: null,
    loading: false,

    tableReady: true
  }),

  mounted() {
    var that = this;
    // this.initTree(t, objName)
    // this.getFieldsTree();

    this.$root.$on("tableMounted", t => {
      if (t.table_title == "report structure") {
        // console.log(t.data_object.headers);
        if (t.formModel.fields.length) {
          var headers = [];
          t.formModel.fields.forEach(f => {
            headers.push({ text: f, value: f });

            t.data_object.headers = headers;
          });
        }
      }
    });
    this.$root.$on("treeFormModelUpdated", t => {
      // console.log(t.tree.formModel);
      if (t.tree.k == "fields") {
        that.initTree(t, t.formModel.parent);
      }
    });
    this.$root.$on("treeUpdated", t => {
      // console.log(t.tree.formModel);
      if (t.tree.k == "fields") {
        if (!t.model || !Object.keys(t.model).length) {
          that.initTree(t, that.defaultModel.parent);
        }
      }
    });
  },

  methods: {
    initTree(t, objName) {
      this.fieldsData.object_name = objName;
      this.treeObject = t.tree;
      this.getFieldsTree();
    },
    getFieldsTree() {
      var that = this;
      if (this.fieldsData) {
        axios
          .post(this.serverURL + "/get_data", this.fieldsData, {
            withCredentials: true
          })
          .then(response => {
            that.populateTree(response.data);
            // this.tableReady = true;

            that.treeObject.items = that.treeItems;
            that.treeObject.updateTree();
            // that.treeObject.$forceUpdate();
            // that.treeObject.treeKey = !that.treeObject.treeKey;
          });
      }
    },
    populateTree(data) {
      this.tree = [];
      this.treeItems = [];
      var chargeNames = {};
      if (data.schema) {
        this.properties = {
          ...data.schema.properties
        };
        this.schema.properties.selected_report_fields.allFields = this.properties;
        // console.log(this.schema?.properties?.selected_report_fields);
      }

      var that = this;
      that.getItem(this.properties, that.treeItems);
    },
    getItem(properties, items, parentPath, parent, parents) {
      if (!parentPath) {
        var categoryLabel = this.categoryLabels ? this.categoryLabels.label : this.data.object_name;
      }
      if (properties) {
        Object.keys(properties).forEach(k => {
          if (!properties[k].hiddenInLetter) {
            // var id = parent ? parent + "." + k : k;
            var id = parentPath ? parentPath + "." + k : k;
            var treeItem = {
              text: id.split(".")[id.split(".").length - 1],
              id: id,
              parentPath: parentPath,
              parent: parent,
              parents: parents,
              hasSummary: properties[k].summary,
              groupable: properties[k].groupable
            };
            items.push(treeItem);
            if (properties[k].properties) {
              treeItem.children = [];
              var p = "";
              if (parentPath) {
                // p = parentPath + "['" + k + "']";
                p = parentPath + "." + k;
              } else {
                p = k;
              }

              this.getItem(properties[k].properties, treeItem.children, p, k, parents);
              // console.log(k.properties);
            }

            if (properties[k]["v-bind"] && properties[k]["v-bind"].objName) {
              var itemValue = properties[k]["v-bind"].itemValue;
              var itemText = properties[k]["v-bind"].itemText;
              treeItem.children = [];

              if (parentPath) {
                // p = parentPath + "['" + k + "']";
                p = parentPath + "." + k;
              } else {
                p = k;
              }
              var v = parentPath ? parentPath + "." + itemValue : itemValue;
              var t = parentPath ? parentPath + "." + itemText : itemText;
              treeItem.children.push({
                text: v,
                id: v,
                parentPath: p,
                parent: k,
                parents: parents
              });
              treeItem.children.push({
                text: t,
                id: t,
                parentPath: parentPath,
                parent: k,
                parents: parents
              });
            }
          }
          // that.treeItems.push(treeItem);
        });
      }

      // return treeItem;
    },

    getParentPath(text) {
      var getPath = function(items) {
        var path = "";
        items.forEach(t => {
          if (path) {
            return path;
          }
          if (t.children) {
            path = getPath(t.children);
          } else {
            if (t.text == text) {
              path = t.parentPath;
            }
          }
        });
        return path;
      };

      var parentPath = getPath(this.treeItems);
      return parentPath;
    },
    beforeSave(m) {
      console.log(m);
      m.selected_report_fields = JSON.stringify(m.selected_report_fields);
      // m.permissions = this.full_permissions;
    },

    onDataReceived(d) {
      this.schema = d.schema;
      d.schema.properties.fields["v-bind"].items = this.treeItems;
      // d.schema.properties.fields["v-bind"].insertAtCursor = this.insertAtCursor;
      var dates = [];

      // var serviceProperties =
      //   d.additional_structure.v_shipments_report.properties;
      d.model.forEach(m => {
        try {
          m.selected_report_fields = JSON.parse(m.selected_report_fields);
        } catch (d) {
          //
        }
      });

      Object.keys(d.additional_structure).forEach(s => {
        // if (s != "v_shipment_letter_fields") {
        // serviceProperties = {
        //   ...serviceProperties,
        //   ...d.additional_structure[s].properties,
        // };
        Object.keys(d.additional_structure[s].properties).forEach(p => {
          if (p.includes("_date") || p == "etd" || p == "eta") {
            dates.push({ p, s });
          }
        });
        //   Object.keys(shipmentDetailProperties).forEach((p) => {
        //     if (p.includes("_date")) {
        //       dates.push({ p, s });
        //     }
        //   });
        //   // }
      });

      console.log(dates);
      d.schema.properties.dates["v-bind"].items = dates;
      return d;
    }
  }
};
</script>

<style scoped></style>
